import {AddDataUrlType} from './types/url.type';

export const AddDataUrlValues: Array<{id: AddDataUrlType; text: string}> = [
  {
    id: 'wms',
    text: 'WMS',
  },
  {
    id: 'wmts',
    text: 'WMTS',
  },
  {
    id: 'wfs',
    text: 'WFS',
  },
  {
    id: 'kml',
    text: 'KML',
  },
  {
    id: 'gpx',
    text: 'GPX',
  },
  {
    id: 'geojson',
    text: 'GeoJSON',
  },
  {
    id: 'arcgis',
    text: 'ArcGIS Map Server',
  },
  {
    id: 'geosparql',
    text: 'GeoSPARQL',
  },
];
